"use client"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Box } from "@mui/material"
import { useNotification } from "../../contexts/NotificationContext"
import { useAuth } from "../../contexts/AuthContext"
import PageHeader from "../../components/common/PageHeader"
import CustomerForm from "../../components/customers/CustomerForm"
import { createCustomer } from "../../services/customer.service"

const CreateCustomer = () => {
  const navigate = useNavigate()
  const { showNotification } = useNotification()
  const { user, selectedOrganization } = useAuth()
  const [loading, setLoading] = useState(false)

  const organizationId = selectedOrganization?._id || user?.organizationId

  const handleSubmit = async (formData) => {
    setLoading(true)
    try {
      const response = await createCustomer({
        ...formData,
        organizationId,
      })
      showNotification("Customer created successfully", "success")
      navigate(`/customers/${response.data._id}`)
    } catch (error) {
      showNotification(error.response?.data?.message || "Failed to create customer", "error")
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box>
      <PageHeader
        title="Create Customer"
        subtitle="Add a new customer to your organization"
        breadcrumbs={[
          { text: "Dashboard", link: "/dashboard" },
          { text: "Customers", link: "/customers" },
          { text: "Create Customer" },
        ]}
      />

      <CustomerForm onSubmit={handleSubmit} loading={loading} />
    </Box>
  )
}

export default CreateCustomer

